<ng-container *transloco="let translate">
	<base-modal #baseModal [showClose]="true" (closed)="_onModalClosed()">
		<div class="w-full text-center">
			<div class="mb-1 text-xxl w-full font-bold">
				{{ translate('home.push_notifications.title') }}
			</div>
			<div class="mt-0.5 text-sp-1.5 leading-l w-full fc-400">
				{{ translate('home.push_notifications.description') }}
			</div>

			<div class="w-full flex items-center justify-center">
				<div class="w-33">
					<img
						class="w-full left-as-is"
						src="/assets/images/complete-registration/notifications.png"
						alt=""
					/>
				</div>
			</div>
		</div>

		<button ngProjectAs="[footer]" uiNewButtonFilled (click)="requestPermission()">
			{{ translate('general.continue') }}
		</button>
	</base-modal>
</ng-container>
